module.exports = ['$translate', $translate => (datetime, format = 'long', fromNowEnabled = false) => {
  if (datetime != null) {
    datetime = moment(datetime);

    if (fromNowEnabled && datetime.isSame(moment(), 'day')) {
      return datetime.fromNow();
    }

    return datetime.format($translate.instant(`date_format.${format}`));
  }
  return null;
}];



// WEBPACK FOOTER //
// ./main/filters/datetime-filter.js